const initialState = {
  loading: true,
  experiments: {},
  variants: {},
}

export default initialState
